import { Flex, Stack, Text } from '@chakra-ui/react'
import type { IconDefinition } from '@fortawesome/fontawesome-common-types'
import type { ReactElement } from 'react'

import Icon from '@/components/UI/Icon/Icon'
import Card from '@/components/Worlds/UI/Card'

type ActionCardItem = {
  icon: IconDefinition
  title: string
  description: string
  onClick: () => void
}

function ActionCard({ icon, title, description, onClick }: ActionCardItem): ReactElement {
  return (
    <Card
      clickable
      withBoxShadow
      hideBorder
      onClick={onClick}
      bg="white"
      borderRadius="16px"
      px="16px"
      py="24px"
      flex={1}
      minHeight="116px"
      display="flex"
      alignItems="center"
    >
      <Flex align="center" gap="16px">
        <Icon
          faIcon={icon}
          size="lg"
          backgroundColor="primary.subtle"
          color="primary.fg"
          rounded
          overrideBoxSideLength="36px"
        />
        <Stack spacing="0px">
          <Text variant="body-title-large" color="primary.fg">
            {title}
          </Text>
          <Text color="fg.muted">{description}</Text>
        </Stack>
      </Flex>
    </Card>
  )
}

export function ActionCards({ items }: { items: ActionCardItem[] }): ReactElement {
  return (
    <Flex gap="10px" direction={{ base: 'column', md: 'row' }}>
      {items.map(item => (
        <ActionCard key={item.title} {...item} />
      ))}
    </Flex>
  )
}
